import algartech from './algartech.svg'
import yorkdigital from './yorkdigital.svg'
import sankhya from './sankhya.svg'
import callink from './callink.svg'
import expocaccer from './expocaccer.png'
import carrodeboi from './carrodeboi.png'

const logos = { algartech, yorkdigital, sankhya, callink, expocaccer, carrodeboi }

export default logos